import classNames from 'classnames'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { formatNumero } from '@/utility/Utils'
import styles from './style.module.css'

interface PaginationProps {
  pageIndex: number
  totalPages: number
  totalItems: number
  onPageChange: (pageNumber: number) => void
}

const MAX_VISIBLE = 5

const buildPages = (pageIndex: number, totalPages: number): number[] => {
  if (totalPages <= MAX_VISIBLE) {
    return Array.from({ length: totalPages }, (_, index) => index + 1)
  }

  const half = Math.floor(MAX_VISIBLE / 2)
  const start = Math.min(Math.max(pageIndex - half, 1), totalPages - MAX_VISIBLE + 1)

  return Array.from({ length: MAX_VISIBLE }, (_, index) => start + index)
}

const Pagination = ({ onPageChange, pageIndex, totalItems, totalPages }: PaginationProps) => {
  if (totalPages <= 1) {
    return <span className={styles.total}>{formatNumero(totalItems)} registro(s)</span>
  }

  return (
    <div className={styles.wrapper}>
      <span className={styles.total}>{formatNumero(totalItems)} registro(s)</span>

      <nav className={styles.pages} aria-label="Paginação">
        <button
          type="button"
          className={styles.page}
          onClick={() => onPageChange(pageIndex - 1)}
          disabled={pageIndex <= 1}
          aria-label="Página anterior"
        >
          <ChevronLeft size={16} />
        </button>

        {buildPages(pageIndex, totalPages).map((page) => (
          <button
            key={page}
            type="button"
            className={classNames(styles.page, { [styles.active]: page === pageIndex })}
            onClick={() => onPageChange(page)}
            aria-current={page === pageIndex ? 'page' : undefined}
          >
            {page}
          </button>
        ))}

        <button
          type="button"
          className={styles.page}
          onClick={() => onPageChange(pageIndex + 1)}
          disabled={pageIndex >= totalPages}
          aria-label="Próxima página"
        >
          <ChevronRight size={16} />
        </button>
      </nav>
    </div>
  )
}

export default Pagination
